import { LOCALSTORAGEKEYS } from "../../common/constants";
import { initStore } from "../store";

const authenticationStore = () => {
  const actions = {
    SAVE_JWT_TOKEN: (state, [accessToken, expiration, refreshToken, ssoToken]) => {
      localStorage.setItem(LOCALSTORAGEKEYS.ACCESSTOKEN, accessToken);
      localStorage.setItem(LOCALSTORAGEKEYS.EXPIRATION, expiration);
      localStorage.setItem(LOCALSTORAGEKEYS.REFRESHTOKEN, refreshToken);
      localStorage.setItem(LOCALSTORAGEKEYS.SSOTOKEN, ssoToken);
      return {
        ...state,
        accessToken: accessToken,
        expiration: expiration,
        refreshToken: refreshToken,
        ssoToken: ssoToken,
      };
    },
    SAVE_USERNAME: (state, username) => {
      localStorage.setItem(LOCALSTORAGEKEYS.USERNAME, username);
      return { ...state, username: username };
    },
    SAVE_USER: (state, user) => {
      if (user) {
        localStorage.setItem(LOCALSTORAGEKEYS.USER, JSON.stringify(user));
      }
      return { ...state, user: user };
    },
    CLEAR_DATA: (state) => {
      const items = [
        LOCALSTORAGEKEYS.ACCESSTOKEN,
        LOCALSTORAGEKEYS.EXPIRATION,
        LOCALSTORAGEKEYS.REFRESHTOKEN,
        LOCALSTORAGEKEYS.USERNAME,
        LOCALSTORAGEKEYS.USER,
        LOCALSTORAGEKEYS.SSOTOKEN,
      ];
      items.forEach((x) => {
        localStorage.removeItem(x);
        state[x] = null;
      });

      return { ...state };
    },
  };

  initStore(
    actions,
    (() => {
      const token = localStorage.getItem(LOCALSTORAGEKEYS.ACCESSTOKEN);
      const expiration = localStorage.getItem(LOCALSTORAGEKEYS.EXPIRATION);
      const refresh = localStorage.getItem(LOCALSTORAGEKEYS.REFRESHTOKEN);
      const username = localStorage.getItem(LOCALSTORAGEKEYS.USERNAME);
      let user = localStorage.getItem(LOCALSTORAGEKEYS.USER);
      if (user && user !== "" && typeof user === "string" && user !== "[object Object]") {
        user = JSON.parse(user);
      }

      return {
        accessToken: token,
        expiration: expiration,
        refreshToken: refresh,
        username: username,
        user: user,
      };
    })()
  );
};

export default authenticationStore;
